import { fetchGet } from '../fetch';
import { getOptions } from '../utils';
import { autosuggestOptionsToQuery } from './autosuggest';
export const autosuggestSelection = (rawInput, selection, rank, options = {}, sourceApi = 'text') => {
    const W3W_DOMAIN_REGEX = /(what3words.com|w3w.io)/gi;
    const baseUrl = getOptions().baseUrl;
    if (baseUrl && !W3W_DOMAIN_REGEX.test(baseUrl))
        return Promise.resolve(null);
    return fetchGet('autosuggest-selection', Object.assign({ 'raw-input': rawInput, selection, rank: rank.toString(), 'source-api': sourceApi }, autosuggestOptionsToQuery(options)));
};
//# sourceMappingURL=autosuggest-selection.js.map